import { useEffect, useMemo } from 'react';
import { Settings } from '@weave/schema-gen-ts/dist/schemas/user-preferences/user_preferences.pb';
import { useMutation } from 'react-query';
import { UserPreferences1 } from '@frontend/api-user-preferences';
import { preferenceActions } from '../store';
import { StoredPreference } from '../types';

export const usePreferencesBootstrap = () => {
  const query = UserPreferences1.Queries.useGetUserPreferencesQuery({});

  const transformedPrefs = useMemo(() => {
    if (!query.data) {
      return;
    }
    const userSettingsMap = query.data?.userSettingsMap || {};
    const result: Record<string, StoredPreference> = {};

    Object.entries(userSettingsMap).forEach(([id, pref]: [string, Settings]) => {
      result[id] = {
        id,
        value: JSON.parse(pref.settingValue || ''),
        updatedAt: pref.updatedAt || '',
      };
    });

    return result;
  }, [query.data]);

  useEffect(() => {
    if (transformedPrefs) {
      preferenceActions.setPreferences(transformedPrefs);
      preferenceActions.setDataInitialized(true);
    }
  }, [transformedPrefs]);

  return {
    data: transformedPrefs,
    isLoading: query.isLoading,
    error: query.error,
  };
};

export const usePreferenceMutation = () => {
  const updatePreferenceMutation = UserPreferences1.Mutations.useUpdateUserPreferencesMutation();
  return useMutation({
    mutationFn: async (preference: { id: string; value: any; updatedAt: string }) => {
      const payload = {
        userSettingsMap: {
          [preference.id]: JSON.stringify(preference.value),
        },
        updatedAt: preference.updatedAt,
      };
      updatePreferenceMutation.mutateAsync(payload);
      return preference;
    },
  });
};

export const usePreferenceBulkMutation = () => {
  const updatePreferenceMutation = UserPreferences1.Mutations.useUpdateUserPreferencesMutation();
  return useMutation({
    mutationFn: async (newUserSettingsMap: Record<string, string>) => {
      const payload = {
        userSettingsMap: { ...newUserSettingsMap },
        updatedAt: new Date().toISOString(),
      };
      updatePreferenceMutation.mutateAsync(payload);
      return newUserSettingsMap;
    },
  });
};
